import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  EudsOpcoBrandingModule, EudsSmartHeaderSimpleModule, EudsSmartFooterSimpleModule, EudsButtonModule, EudsSelectModule, EudsDataTableModule, EudsPaginationModule,
  EudsTextFilterModule, EudsFilterModule, EudsDatePickerModule, EudsSvgModule, EudsTabNavModule, EudsModalModule, EudsAccordionModule, EudsCardModule, EudsTextareaModule,
  EudsIconListModule, EudsAlertModule, EudsTextfieldModule, EudsLoaderModule, EudsNavContainerModule, EudsTagModule, EudsAutocompleteModule, EudsTooltipModule
} from '@eucoms/common-components/design-system';
import { EuCoreServicesModule } from '@eucoms/common-components';
import {
  OpCo,
  DEFAULT_CONFIG_ENDPOINT, DEFAULT_SESSION_ENDPOINT, ALERTS_ENDPOINT
} from '@eucoms/common-components';
import { TouchPointsComponent } from './pages/touchpoints/touchpoints.component';
import { ShareComponent } from './components/share/share.component';
import { SummaryComponent } from './pages/summary/summary.component';
import { LogComponent } from './pages/log/logging.component';
import { RealTimePreviewComponent } from './pages/preview/preview.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApiService } from './services/api.service';
import { PreviousRouteService } from './services/previous-route.service';
import { TouchpointFormComponent } from './pages/touchpoint-form/touchpoint-form.component';
import { CustomerAlertCxwComponent } from './components/customer-alert-cxw/customer-alert-cxw.component';
import { FeedbackToggleComponent } from './components/feedback-toggle/feedback-toggle.component';
import { CustomerAlertSapComponent } from './components/customer-alert-sap/customer-alert-sap.component';
import { CustomerTouchPointsService } from './services/customer.touchpoints.service';
import { SummaryDetailsComponent } from './components/summary-details/summary-details.component';
import { AuthService } from './services/auth.service';
import { SharedModule } from './shared/shared.module';
import { initilizeMsal, MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './msal-app-init';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalRedirectComponent } from '@azure/msal-angular';

let devBaseUrl = 'https://azstage.bge.com';

const CoreServicesInitOptions = {
  configEndpoint: devBaseUrl + DEFAULT_CONFIG_ENDPOINT,
  sessionEndpoint: devBaseUrl + DEFAULT_SESSION_ENDPOINT,
  alertsEndpoint: devBaseUrl + ALERTS_ENDPOINT,
  additionalConfig: {
    common: {
      opCo: 'BGE',
      baseUrl: devBaseUrl,
    }
  },
}
@NgModule({
  declarations: [
    AppComponent,
    TouchPointsComponent,
    SummaryComponent,
    LogComponent,
    RealTimePreviewComponent,
    TouchpointFormComponent,
    SummaryDetailsComponent,
    CustomerAlertCxwComponent,
    CustomerAlertSapComponent,
    FeedbackToggleComponent,
    ShareComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MsalModule,
    ReactiveFormsModule,
    SharedModule,
    EudsSmartHeaderSimpleModule,
    EudsSmartFooterSimpleModule,
    EudsOpcoBrandingModule,
    EudsButtonModule,
    EudsDataTableModule,
    EudsPaginationModule,
    EudsTextFilterModule,
    EudsSelectModule,
    EudsFilterModule,
    EudsDatePickerModule,
    EudsSvgModule,
    EudsTabNavModule,
    EudsModalModule,
    EudsAccordionModule,
    EudsCardModule,
    EudsTextareaModule,
    EudsIconListModule,
    EudsAlertModule,
    EudsTextfieldModule,
    EudsLoaderModule,
    EudsNavContainerModule,
    EudsTagModule,
    EudsAutocompleteModule,
    EudsTooltipModule
    // EuCoreServicesModule.forRoot(CoreServicesInitOptions),
  ],
  providers: [
    // MSAL Providers
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initilizeMsal,
      deps: [MsalService],
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    // AppConfigService,
    /*

    The following mockAppConfigService code should only be used to mock the AppConfigService for local testing.
    This should NOT be used in production code.
    Reference the Confluence documentation below for best practices on getting EUCOMS to work with the AppConfigService.
    https://exelonutilities.atlassian.net/wiki/spaces/SAT/pages/413892615/Local+Development+Setup

    After EUCOMS has been configured to work locally, the mock is no longer needed, and the AppConfigService can be used.
    Once EUCOMS has been configured to work locally,
    - Un-comment line 32 EuCoreServicesModule.forRoot(CoreServicesInitOptions),
    - Un-comment line 35 AppConfigService,
    - Comment out lines 50-58 (the mock code)

    */
    ApiService,
    PreviousRouteService,
    CustomerTouchPointsService,
    AuthService,
    EuCoreServicesModule.mockAppConfigService({
      common: {
        opCo: OpCo.BGE,
        baseUrl: 'https://secure.bge.com',
        anonBaseUrl: 'https://www.bge.com',
        euApiUrl: 'https://eudapi.bge.com',
        contentApiRoutePrefix: '/content-api',
      }
    }),

  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
